import { combineReducers } from "redux";
import commonReducer from "./commonReducer";
import motorReducer from "./motorReducer";
export default combineReducers({
    motor: motorReducer,
    common: commonReducer,
});
